import axios from 'axios'

const currentUrl = window.location.href
let url = ''

if (currentUrl.includes('onclub-admin.pages.dev/')) {
  // url = 'https://api.onclubapp.com.br/api/v1/'
  // url = 'https://onclub-backend.onrender.com/api/v1/'
  url = 'https://onclub-backend-ma3r.onrender.com/api/v1/'
} else if (currentUrl.includes(':300')) {
  // url = 'https://onclub-backend-ma3r.onrender.com/api/v1/'
  url = 'http://localhost:3001/api/v1/'
  // url = 'https://onclub-backend.onrender.com/api/v1/'
}

const provider = axios.create({
  baseURL: url,
})

export default provider
